import { Platform, StyleSheet } from "react-native";
import { theme } from "../../../theme";
export const styles = StyleSheet.create({
    label: {
        ...theme.fontDefaults.small,
        marginBottom: theme.spacing.xsmall2,
    },
    message: {
        marginTop: theme.spacing.xsmall2,
    },
    invertErrorColors: {
        backgroundColor: theme.colors.negative.base,
    },
    field: {
        width: "100%",
        marginVertical: Platform.OS === "web" ? theme.spacing.small : theme.spacing.xsmall,
    },
});
//# sourceMappingURL=Field.styles.js.map